import { List } from "immutable";

import { composeSelector } from "seneca-common/utils/selectors/compose-selectors";

import { PATH_TO_STUDENT_PARENTS_STATE } from "../consts";
import StudentParentsStateSlice from "../models/StudentParentsStateSlice";
import * as stateSliceSelectors from "./state";

type State = any;

function getStudentParentsStateSlice(state: State): StudentParentsStateSlice {
  return state.get(PATH_TO_STUDENT_PARENTS_STATE);
}

export const getStudentParentIds: (state: State) => List<string> =
  composeSelector(
    getStudentParentsStateSlice,
    stateSliceSelectors.getParentIds
  );

export const isParentLinked: (state: State, parentId: string) => boolean =
  composeSelector(
    getStudentParentsStateSlice,
    stateSliceSelectors.isParentLinked
  );

export const getParentIdByCode: (
  state: State,
  parentCode: string
) => string | null | undefined = composeSelector(
  getStudentParentsStateSlice,
  stateSliceSelectors.getParentIdByCode
);

export const studentAlreadyLinkedToParent: (state: State) => boolean =
  composeSelector(
    getStudentParentsStateSlice,
    stateSliceSelectors.studentAlreadyLinkedToParent
  );

// meta
//fetch
export const studentParentsAreFetching: (arg0: State) => boolean =
  composeSelector(
    getStudentParentsStateSlice,
    stateSliceSelectors.studentParentsAreFetching
  );
export const studentParentsFetchSucceeded: (arg0: State) => boolean =
  composeSelector(
    getStudentParentsStateSlice,
    stateSliceSelectors.studentParentsFetchSucceeded
  );
export const studentParentsFetchErrored: (arg0: State) => boolean =
  composeSelector(
    getStudentParentsStateSlice,
    stateSliceSelectors.studentParentsFetchErrored
  );
export const studentParentsFetchFinished: (arg0: State) => boolean =
  composeSelector(
    getStudentParentsStateSlice,
    stateSliceSelectors.studentParentsFetchFinished
  );
export const studentParentsNeedFetching: (arg0: State) => boolean =
  composeSelector(
    getStudentParentsStateSlice,
    stateSliceSelectors.studentParentsNeedFetching
  );
//update
export const studentParentIsUpdating: (arg0: State) => boolean =
  composeSelector(
    getStudentParentsStateSlice,
    stateSliceSelectors.studentParentIsUpdating
  );
export const studentParentUpdateSucceeded: (arg0: State) => boolean =
  composeSelector(
    getStudentParentsStateSlice,
    stateSliceSelectors.studentParentUpdateSucceeded
  );
export const studentParentUpdateErrored: (arg0: State) => boolean =
  composeSelector(
    getStudentParentsStateSlice,
    stateSliceSelectors.studentParentUpdateErrored
  );
export const studentParentUpdateFinished: (arg0: State) => boolean =
  composeSelector(
    getStudentParentsStateSlice,
    stateSliceSelectors.studentParentUpdateFinished
  );
export const studentParentUpdateErrorMessage: (arg0: State) => string =
  composeSelector(
    getStudentParentsStateSlice,
    stateSliceSelectors.studentParentUpdateErrorMessage
  );

export const userAttemptsToConnectToOwnAccount: (arg0: State) => boolean =
  composeSelector(
    getStudentParentsStateSlice,
    stateSliceSelectors.userAttemptsToConnectToOwnAccount
  );
